// Perfil Logística: usuário manual (ESF), sem vínculo com colaborador do ERP,
// que reaproveita ROLE_COORDINATOR para não exigir mudança na API. Um
// coordenador sincronizado pelo ERP também tem esse role, mas vem com
// `colaborador.id` e não pode ser confundido com Logística.
export const ROLE_LOGISTICA = 'ROLE_COORDINATOR';

type UsuarioComOrigem = {
  role?: string;
  origem_cadastro?: string;
  colaborador?: { id?: string | null };
};

export const ehLogistica = (user?: UsuarioComOrigem | null): boolean => {
  if (user?.role !== ROLE_LOGISTICA) return false;

  // As telas de administração recebem origem_cadastro diretamente.
  if (user.origem_cadastro) return user.origem_cadastro === 'ESF';

  // O login não devolve origem_cadastro, mas sempre devolve colaborador.
  // Usuários manuais não possuem esse vínculo; usuários do ERP possuem.
  return !user.colaborador?.id;
};
